export default "<div id=\"divider\"></div>\n"